import { useGetPerson, useGetPersonsSummary } from '@hr/api/endpoints'
import { Button } from '@hr/common/Button.tsx'
import { LoadingWrapper } from '@hr/common/LoadingState.tsx'
import { useCurrentUser } from '@hr/hooks/useCurrentUser.ts'
import { useGetAbscenceTypesOptionsOnlyActive } from '@hr/mgmtview/personalprofile/newabscencemodal/useGetAbscenceTypesOptionsOnlyActive.ts'
import { type Dispatch, type FC, type SetStateAction, useMemo } from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { NewAbscenceModalForm } from './NewAbscenceModalForm'

interface NewAbscenceModalProps {
	setIsOpen: Dispatch<SetStateAction<boolean>>
	event?: any & { personId?: string; approvers?: Array<{ id: string }> } // temporary any;
	openedByDateClick?: boolean
}

export const NewAbscenceModal: FC<NewAbscenceModalProps> = ({ setIsOpen, event, openedByDateClick }) => {
	const { t } = useTranslation()
	const { options: abscenceOptions } = useGetAbscenceTypesOptionsOnlyActive()
	const currentUser = useCurrentUser()
	const { data: eventPerson } = useGetPerson(event?.personId ?? '', {
		query: { enabled: !!event?.personId },
	})
	const { data: supervisors } = useGetPersonsSummary('all')
	const user = useMemo(() => eventPerson || currentUser, [eventPerson, currentUser])
	const isEdit = event?.id

	const isVisible = () => {
		if (isEdit) {
			return !!eventPerson && !!user && !!supervisors
		}
		return !!user && !!supervisors
	}

	return (
		<Modal show size="lg" onHide={() => setIsOpen(false)} centered>
			<Modal.Header closeButton>
				<Modal.Title>{isEdit ? t('EditEvent', 'Muokkaa tapahtumaa') : t('AddEvent', 'Lisää tapahtuma')}</Modal.Title>
			</Modal.Header>
			{!isVisible() && (
				<>
					<Modal.Body className="d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
						<LoadingWrapper isLoading={true} />
					</Modal.Body>

					<Modal.Footer className="d-flex justify-content-st">
						<Button variant="secondary" onClick={() => setIsOpen(false)}>
							{t('Close')}
						</Button>
					</Modal.Footer>
				</>
			)}

			{isVisible() && (
				<NewAbscenceModalForm
					supervisors={supervisors}
					user={user}
					setIsOpen={setIsOpen}
					openedByDateClick={openedByDateClick}
					event={event}
					abscenceOptions={abscenceOptions}
				/>
			)}
		</Modal>
	)
}
